const Cta = () => {
  return (
    <div className="cta">
      <a
        href={`${window.location.origin}/resume/Amirhossein-Ebrahimi-v-0.pdf`}
        download
        className="btn"
      >
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default Cta;
